<template>
  <div>
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-overflow-btn
      v-model="$i18n.locale"
      :items="langs"
      label="lang"
      outlined
      @change="changeLanguage"
    ></v-overflow-btn>

  </div>
</template>

<script>
import { userVar } from '@/js/auth/userVar'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      langs: ['fr', 'nl'],
      httpalert: false
    }
  },

  methods: {
    changeLanguage () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        options: 'set',
        name: 'lang',
        value: this.$i18n.locale,
        key: this.$store.state.auth.token
      }
      userVar(params)
        .then(response => {
          if (response.data !== 'OK' && response.data !== 'ok') {
            // this.$store.dispatch('auth/authLogout')
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          }
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
          // this.$store.dispatch('auth/authLogout')
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
